<template>
    <div class="page">
        <!--<div class="page-hd">-->
            <!--<myNav>{{title}}</myNav>-->
        <!--</div>-->
        <div class="page-bd">
            <Button type="primary" @click="openSave()">{{ $t("upd")}}</Button>
            <Button type="primary" @click="openSetup()" v-if="org_level == '0'">{{ $t("set_add")}}</Button>
            <Button type="primary" v-print="printObj" >{{ $t("print")}}</Button>
            <table class="info-box" id="print_area">
                <tr>
                    <td class="org-cname" colspan="4">{{info.org_cname}}</td>
                </tr>
                <tr>
                    <td class="cell_name">{{ $t("code")}}</td>
                    <td colspan="2">{{info.org_code}}</td>
                    <td rowspan="6" class="img-lnk">
                        <img :src="info.img_lnk"/></td>
                </tr>
                <tr>
                    <td class="cell_name">{{ $t("org_grade")}}</td>
                    <td colspan="1">{{info.org_grade_cdesc}}</td>
                </tr>
                <tr>
                    <td class="cell_name">{{ $t("org_cid")}}</td>
                    <td colspan="1">{{info.org_cid}}</td>
                </tr>
                <tr>
                    <td class="cell_name">{{ $t("org_cor")}}</td>
                    <td colspan="1">{{info.org_cor}}</td>
                </tr>
                <!--<tr>
                    <td class="cell_name">{{ $t("org.info.org_addr_code")}}</td>
                    <td colspan="1">{{info.org_addr_code}}</td>
                </tr>-->
                <tr>
                    <td class="cell_name">{{ $t("cat_id")}}</td>
                    <td colspan="1">{{info.org_level_cdesc}}</td>
                </tr>
                <tr>
                    <td class="cell_name">{{$t("status")}}</td>
                    <td colspan="1">{{info.org_status_cdesc}}</td>
                </tr>
                <tr>
                    <td class="cell_name">{{$t("org_location")}}</td>
                    <td colspan="3">
                        {{info.org_prov}}{{info.org_city}}{{info.org_area}}
                        <!--{{info.org_prov}}{{$t("org.info.org_prov")}}{{info.org_city}}{{$t("org.info.org_city")}}{{info.org_area}}{{$t("org.info.org_area")}}-->
                    </td>
                </tr>
                <tr>
                    <td class="cell_name">{{ $t("org_addr")}}</td>
                    <td colspan="3">{{info.org_addr}}</td>
                </tr>
                <tr>
                    <td class="cell_name">{{ $t("org_contact")}}</td>
                    <td colspan="3">{{info.link_cname}}</td>
                </tr>
                <tr>
                    <td class="cell_name">{{ $t("org_mobile")}}</td>
                    <td colspan="3">{{info.link_mobile}}</td>
                </tr>
                <tr>
                    <td class="cell_name">{{ $t("cu_cname")}}</td>
                    <td colspan="3">{{info.cu_cname}}</td>
                </tr>
                <tr>
                    <td class="cell_name">{{ $t("cu_mobile")}}</td>
                    <td colspan="3">{{info.cu_mobile}}</td>
                </tr>
                <tr>
                    <td class="cell_name">{{ $t("cu_ser_time")}}</td>
                    <td colspan="3">{{info.cu_time_area}}</td>
                </tr>
                <tr>
                    <td class="cell_name">{{ $t("cdesc")}}</td>
                    <td colspan="3">{{info.org_cdesc}}</td>
                </tr>
                <tr>
                    <td class="cell_name">{{ $t("org_admin_code")}}</td>
                    <td colspan="3">{{info.org_admin_code}}</td>
                </tr>
                <tr>
                    <td class="cell_name">{{ $t("build_img_lnk")}}</td>
                    <td colspan="3" class="img-cid-lnk"><img :src="info.build_img_lnk"/></td>
                </tr>
                <tr>
                    <td class="cell_name">{{ $t("cid_img_lnk")}}</td>
                    <td colspan="3" class="img-cid-lnk"><img :src="info.cid_img_lnk"/></td>
                </tr>
            </table>
        </div>
        <Drawer class="drawer-sub-view" :title="sub_title" v-model="show_subview" width="820" :mask-closable="false"
                placement="left" :closable="false">
            <router-view></router-view>
        </Drawer>
    </div>
</template>

<script>
    import myNav from "../../../components/myNav"
    import myToolbar from '../../../components/myToolbar'
    import myNodata from '../../../components/myNodata'
    export default {
        name:"org-info",
        components:{
            myNav,
            myToolbar,
            myNodata,
        },
        data:function(){
            return{
                title: this.$t('info'),
                sub_title:'',//子界面名称
                show_subview:false,
                relist:false,
                org_level: this.$base.getOrgLevel(),
                search:{
                    search_url:'org/info',
                },
                listTable: {},//表结构
                listData: [],
                totalData: {
                    total: 0,//总行数
                },
                info: {},
                printObj:{
                    id:'#print_area',
                    popTitle: '-',
                    endCallback(){}
                }
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.list();
        },
        methods:{
            list: function () {
                this.$base.showLoading();
                this.$request.sendPost(this.search.search_url,this.search,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.info = data;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            openSave:function () {
                this.sub_title = this.$t('info');
                this.$base.linkTo("/org/info/save",{});
            },
            openSetup:function () {
                this.sub_title = this.$t('set_add');
                this.$base.linkTo("/org/info/setup",{data: JSON.stringify(this.info)});
            }
        },
        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.list(this.search.page);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped >
    .info-box{
        border: solid 1px #e5e5e5;
        min-width: 800px;
        margin-top: 10px;
        background-color: #fff;
        border-collapse:collapse;
    }
    .info-box tr{
        border-top: solid 1px #e5e5e5;
    }
    .info-box td{
        padding: 10px;
    }
    .info-box .cell_name{
        background-color: #f8f8f8;
        width: 150px;
    }

    .info-box .location_cell_name{
        background-color: #f8f8f8;
        width: 100px;
    }

    .info-box .org-cname{
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        padding: 10px 0;
        background-color: #2b2b2b;
        color: #fff;
    }
    .info-box .img-lnk{
        text-align: center;
        background-color: #f8f8f8;
    }
    .info-box .img-lnk img{
        width: 150px;
        max-height: 150px;
    }
    .info-box .img-cid-lnk img{
        width: 350px;
    }

    .info_container {
        margin-top: 20px;
        width: 80%;
        background-color: white;
        padding: 20px;
    }

    span.info-title,span.info-message{
        font-size: 16px;
        line-height: 20px;
        vertical-align: middle
    }

    .icon-style{
        display: inline-block;
        margin-right: 10px;
        height:auto;  }

    .info-col-style{
        margin-bottom: 8px;
        vertical-align: middle;
    }

    .ivu-row>* {vertical-align: middle!important;}


    .img-style-div img{
        width: 80px;
        height: 80px;
    }

</style>



// WEBPACK FOOTER //
// src/pages/org/info/info.vue